import GeneratedDoc from "./generated-doc"
import { ChipVariant } from "Components/atoms/chip"



export enum GEN_DOC_STATUS {
    APPROVE = "Approved",
    DRAFT = "Draft",
    PENDING = "Pending",
    REJECT = "Reject"
}

// Statuses are DB rows, so anything seeded later falls through to the default.
export const GEN_DOC_STATUS_VARIANT: Record<string, ChipVariant> = {
    [GEN_DOC_STATUS.APPROVE]: 'success',
    [GEN_DOC_STATUS.PENDING]: 'info',
    [GEN_DOC_STATUS.DRAFT]: 'warning',
    [GEN_DOC_STATUS.REJECT]: 'danger',
}

interface GenDocStatus {
    id: string
    description: string

    generatedDocs?: GeneratedDoc[]
}

export default GenDocStatus